import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as HomeIcon } from "../assets/calendar.svg";
import { ReactComponent as WinIcon } from "../assets/victory.svg";
import { ReactComponent as UpIcon } from "../assets/upgrade.svg";
import { ReactComponent as MatchIcon } from "../assets/rating.svg";
import { ReactComponent as ProfileIcon } from "../assets/profile.svg";

const BottomNavigation = () => {
  const [active, setActive] = useState();

  const handleNavClick = (page) => {
    setActive(page);
  };

  return (
    <div className="bottom-navigation">
      <NavLink
        to="/"
        className={`nav-button ${active === 'home' ? 'active' : ''}`}
        onClick={() => handleNavClick('home')}
      >
        <HomeIcon className='nav-icon' />
      </NavLink>
      <NavLink
        to="/victories"
        className={`nav-button ${active === 'clock' ? 'active' : ''}`}
        onClick={() => handleNavClick('clock')}
      >
        <WinIcon className="nav-icon" />
      </NavLink>
      <NavLink
        to="/upgrade"
        className={`nav-button ${active === 'star' ? 'active' : ''}`}
        onClick={() => handleNavClick('star')}
      >
        <UpIcon className="nav-icon" />
      </NavLink>
      <NavLink
        to="/rating"
        className={`nav-button ${active === 'heart' ? 'active' : ''}`}
        onClick={() => handleNavClick('heart')}
      >
        <MatchIcon className="nav-icon" />
      </NavLink>
      <NavLink
        to="/profile"
        className={`nav-button ${active === 'settings' ? 'active' : ''}`}
        onClick={() => handleNavClick('settings')}
      >
        <ProfileIcon className="nav-icon" />
      </NavLink>
    </div>
  );
};

export default BottomNavigation;
